import React from 'react';
import WorkSessionsTableHeader from './WorkSessionsTableHeader';
import WorkSessionsTableRow from './WorkSessionsTableRow';
import type {
  DayStatistics,
  LateUserStatistics,
  UserStatistics,
  WorkSessionsByUser,
  WorkSessionsTableUser,
} from './types';

type Props = {
  dates: Array<Date>;
  displayedUsers: Array<WorkSessionsTableUser>;
  workSessionsByUser: WorkSessionsByUser;
  statisticsByUser: Array<UserStatistics>;
  statisticsByDay: Array<DayStatistics>;
  lateStatisticsByUser: Array<LateUserStatistics>;
  showOnlyLateFilter: boolean;
  onToggleLateFilter: () => void;
};

const WorkSessionsTableMatrix = ({
  dates,
  displayedUsers,
  workSessionsByUser,
  statisticsByUser,
  statisticsByDay,
  lateStatisticsByUser,
  showOnlyLateFilter,
  onToggleLateFilter,
}: Props): React.ReactElement => (
  <table className="table" border={1} cellPadding={8} style={{ borderCollapse: 'collapse', width: '100%' }}>
    <colgroup>
      <col className="user-column" />
      {dates.map(dateObj => (
        <col key={dateObj.toISOString()} className="day-column" />
      ))}
    </colgroup>
    <WorkSessionsTableHeader
      dates={dates}
      statisticsByDay={statisticsByDay}
      showOnlyLateFilter={showOnlyLateFilter}
      onToggleLateFilter={onToggleLateFilter}
    />
    <tbody>
      {displayedUsers.map(user => (
        <WorkSessionsTableRow
          key={user.id}
          user={user}
          dates={dates}
          workSessionsByUser={workSessionsByUser}
          statisticsByUser={statisticsByUser}
          lateStatisticsByUser={lateStatisticsByUser}
        />
      ))}
    </tbody>
  </table>
);

export default WorkSessionsTableMatrix;
